import { render, staticRenderFns } from "./ProjectCollectionProjects.vue?vue&type=template&id=24cbc706&"
import script from "./ProjectCollectionProjects.vue?vue&type=script&lang=js&"
export * from "./ProjectCollectionProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24cbc706')) {
      api.createRecord('24cbc706', component.options)
    } else {
      api.reload('24cbc706', component.options)
    }
    module.hot.accept("./ProjectCollectionProjects.vue?vue&type=template&id=24cbc706&", function () {
      api.rerender('24cbc706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectCollectionProjects.vue"
export default component.exports